import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import smoothscroll from 'smoothscroll-polyfill';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import MainProvider from './MainProvider';
import AppContent from './AppContent';

import theme from '../../shared/theme/theme';

// kick off the polyfill!
smoothscroll.polyfill();

// AppContent es quien crea el único RouterProvider de toda la app (ver F2-6 en
// PLAN_MIGRACION.md) -ya no hay un <BrowserRouter> acá arriba: con react-router v6
// usando el data router, tener dos routers (uno acá y el RouterProvider adentro)
// es un anti-patrón no soportado. ScrollToTop también se movió adentro del árbol
// del router (ver AppContent.tsx/ScrollToTop.tsx), porque necesita contexto de router
// para leer la ubicación actual.
const App: React.FC = () => (
  <MainProvider>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <AppContent />
      </ThemeProvider>
    </StyledEngineProvider>
  </MainProvider>
);

export default App;
